import {
    Box,
    useColorModeValue,
    HStack,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Button,
    useDisclosure,
    Image,
    Card, CardHeader, CardBody, CardFooter,
    Stack,
    Heading,
    Text,
    Divider,
    ButtonGroup,
    VStack,
    SimpleGrid,
    AspectRatio,
} from '@chakra-ui/react';

import { TfiClose } from "react-icons/tfi";
import { ChevronRightIcon } from '@chakra-ui/icons';

import React, { } from "react";

import aerialaxon from '../assets/tech4/Image31-CROP.png'
import aerial2 from '../assets/tech4_aerial.png'
import site from '../assets/tech4/Image35-CROPPED.png'
import vid_urbanapproach from '../assets/tech4/Video4-urbanapproach.gif'
import vid_towerdolly from '../assets/tech4/Video13-tower.gif'

import vid_idyllic from '../assets/tech4/Video14-idyllic.gif'
import vid_horiz from '../assets/tech4/Video15apt0.gif'
import vid_aerial from '../assets/tech4/Video18.gif'

import concept from '../assets/tech4/concept.png'
import persp from '../assets/tech4/persp.png'
import siteplan from '../assets/tech4/site-plan.png'
import eastsection from '../assets/tech4/east-section.png'
import l1 from '../assets/tech4/L1.png'
import l2 from '../assets/tech4/L2.png'
import l3 from '../assets/tech4/L3.png'
import l4 from '../assets/tech4/L4-11.png'
import roof from '../assets/tech4/Lroof.png'

import siteplanwroof from '../assets/tech4/siteplanwroof.png'
import elevations from '../assets/tech4/elevations.png'
import canopies from '../assets/tech4/canopies.png'
import tower from '../assets/tech4/tower.png'
import pond from '../assets/tech4/pond.png'

export default ProjectModalTech4;

function ProjectModalTech4() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [size, setSize] = React.useState('md')

    const handleSizeClick = (newSize) => {
        setSize(newSize)
        onOpen()
    }

    const sizes = ['full']

    return (
        <>
            {sizes.map((size) => (
                <Button
                    onClick={() => handleSizeClick(size)}
                    key={size}
                    textAlign='left'
                    fontWeight='medium'
                    fontSize={{ base: 'sm', lg: 'sm' }}

                    // p={'-4'}
                    borderRadius={'lg'}
                    border={'1px'}
                    bg={'transparent'}
                    _hover={{
                        transform: "scale(0.98)",
                        transition: 'all .1s ease',
                        color: 'gray.500',
                        bg: 'transparent'
                    }}
                    _active={{
                        transform: "scale(0.96)",
                        transition: 'all .1s ease',
                        color: 'gray.800',
                    }}
                >
                    {/* {`Open ${size} Modal`} */}
                    {`Learn More`}
                    <ChevronRightIcon boxSize={6}
                        // w={8} h={8} 
                        color="pink.400" />
                </Button>
            ))}

            <Modal onClose={onClose} size={size} isOpen={isOpen} blockScrollOnMount={false}>
                <ModalOverlay />
                <ModalContent>
                    <HStack justify={'flex-end'}>
                        <Button onClick={onClose}
                            // justify={'space-between'}
                            align={'left'}
                            _hover={{
                                transform: "scale(0.98)",
                                transition: 'all .1s ease',
                                color: 'gray.500',
                                bg: 'transparent'
                            }}
                            _active={{
                                transform: "scale(0.96)",
                                transition: 'all .1s ease',
                                color: 'gray.800',
                            }}
                            bg={'transparent'}
                        >
                            <TfiClose boxSize={24} />
                        </Button>
                    </HStack>
                    <ModalHeader
                        fontSize={{ base: '3xl', sm: '4xl' }}
                        color={useColorModeValue('black', 'white')}
                        fontWeight='thin'
                        textAlign='center'

                        lineHeight='1'
                        mt={"10px"}
                        mb={"10px"}
                    >
                        <Text
                            textTransform='uppercase'
                            letterSpacing={2}>  Farm to City: Urban Agriscape </Text>
                        <Text
                            letterSpacing={0}
                            my={5}
                            textAlign='center' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
                            color={useColorModeValue('gray.800', 'gray.200')}
                        >
                            📍 281-285 Ferry St, Ironbound, Newark, NJ 07105
                        </Text>
                    </ModalHeader>
                    {/* <ModalCloseButton/> */}

                    <ModalBody>
                        <Box p={'-4'}>
                            {/* <ImageSliderCarousel slides={SlideData} /> */}
                            <ProjectGrid />
                        </Box>
                    </ModalBody>
                    {/* <ModalFooter> <Button onClick={onClose}>Close</Button> </ModalFooter> */}
                </ModalContent>
            </Modal>
        </>
    )
}

const ProjectGrid = () => {
    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={vid_aerial}
                        alt='Rendering: Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Site</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={aerial2}
                        alt='Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    East</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={canopies}
                        alt='Rendering: Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Canopies</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={tower}
                        alt='Rendering: Tower'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Tower</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={persp}
                        alt='Rendering: Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    West</Text>
            </VStack>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={concept}
                        alt='Concept'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Concept</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={siteplan}
                        alt='Site Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Ironbound, Newark, NJ, Context</Text>
            </VStack>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={siteplanwroof}
                        alt='Site Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Site Plan</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={pond}
                        alt='Under the Canopies'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Under the Canopies</Text>
            </VStack>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={l1}
                        alt='L1 Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    L1 Residential Lobby, Grocery Store, Local Businesses</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={l2}
                        alt='L2 Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    L2 Office, Coworking, Fitness & Wellness</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={l3}
                        alt='L3 Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    L3 Fitness & Wellness, Community Garden, Roof Agriculture</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={l4}
                        alt='L4-11 Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    L4-11 Residential, Assisted Living</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={roof}
                        alt='Roof Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Roof Common Area for Residents</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={elevations}
                        alt='East Section'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Elevations</Text>
            </VStack>


        </SimpleGrid>
    );
};
